module.exports = function(media) {
	'use strict'
	media.directive('mediaEditDir',mediaEditDir);
	mediaEditDir.$inject=['downloadImage','jQuery','keyPressOnlyNumber','authtokenService','config','$rootScope','$state','getDataService','refreshtokenService','serverError','alertService','postDataService','deleteDataService','putDataService','$timeout','keyPress', 'checkArray', 'API_URL','offlineError'];
	function mediaEditDir(downloadImage,jQuery,keyPressOnlyNumber,authtokenService,config,$rootScope,$state,getDataService,refreshtokenService,serverError,alertService,postDataService,deleteDataService,putDataService,$timeout,keyPress, checkArray, API_URL,offlineError) {
		return {
			restrict: 'E',
			scope:{
				media:'='
			},
			template: require('./partial/editmedia.html'),
			link: function(scope, ele, $attrs, ctrl) {
				var state ='attachments';
				scope.existTag = false;
				scope.editMediaCurrent = null;
				scope.titleRequired = false;
				scope.newTagRequired = false;
				scope.attachmentId = scope.media.attachmentId;
				scope.imageLocked = false;
				scope.photoRestriction = false;
				scope.attachmentIdsArray = [];
				// scope.approvalUrl = false;
				scope.attachmentIdsArray.push(scope.attachmentId) 
				// var token = authtokenService.getToken();

				scope.numberOfUses = {
					max:undefined,
					count: 0
				}
				var mainImage = angular.element(document.getElementsByClassName("main-image"));
				mainImage.on('error',function() {
					scope.$apply(function() {
						scope.imageLocked = true;
					})
				});
				scope.downloadImage = downloadImage
				scope.ranges = {
			        'Today': [moment().startOf('day'), moment().endOf('day')],
			        'Next 30 days': [moment().startOf('day'), moment().add('days', 29).endOf('day')],
			        'Next 90 days': [moment().startOf('day'), moment().add('days', 89).endOf('day')],
			        'Next 12 months': [moment().startOf('day'), moment().add('months', 12).subtract('days', 1).endOf('day')]
			    };
				// scope.media.dzOptionsRestriction = {
			    //     url : API_URL + 'upload/pdf/approval',
			    //     paramName : 'pdf',
			    //     maxFilesize : '500',
			    //     parallelUploads: 1,
			    //     uploadMultiple: false,
			    //     acceptedFiles : '.pdf',
			    //     addRemoveLinks : true,
			    //     autoProcessQueue : false,
			    //     dictInvalidFileType: 'This file type is not supported.',
			    //     dictFileTooBig:'File size too Big',
			    //     dictDefaultMessage : "Drop approval pdf here to upload",
			    //     headers:{
			    //       'x-auth': token  
			    //     },
			        
			    // };
			    // scope.media.dzCallbacksRestriction = {
			    //     'addedfile' : function(file){
			    //     	if(scope.newFileRestriction) {
			    //     		scope.media.dzMethodsRestriction.removeFile(scope.newFileRestriction);
			    //     	}
			    //         var promise = refreshtokenService.getAccessToken();
			    //         promise.then(
			    //           function(answer) {
			    //                 token = authtokenService.getToken();
			    //                 scope.media.dzOptionsRestriction.headers['x-auth'] = token;
			    //                 scope.media.dzMethodsRestriction.processQueue();
			    //         		scope.newFileRestriction = file;
			    //           },
			    //           function(error) {
			    //             // report something
			    //           },
			    //           function(progress) {
			    //            // report progress
			    //         });
			    //     },
			    //     'success' : function(file, xhr, response){
			    //    		var data = JSON.parse(response.currentTarget.response);
			    //    		scope.approval = data.approval;
			    //     },
			    //     'error' : function(file,message) {
			    //         // console.log(response.xhr.status);
				// 		if(message && message.error && message.error.message) {
				// 			jQuery(file.previewElement).find('.dz-error-message').text(message.error.message);
				// 		}
			    //     },
			    //     'sending':function(file, xhr, formData) {
			    //          formData.append('attachment_ids', scope.attachmentIdsArray);
			    //     }
			    // };
			    var resetRestrictionFunction = function() {
			        scope.$broadcast('clear-daterange');
			        scope.numberOfUses.max = undefined;
			        // scope.approval = undefined; 
			    }
			    scope.addPhotoRestriction = function() {
			    	if(!scope.photoRestriction) {
			         	resetRestrictionFunction();
			    	}
			    }
			    scope.changeDate = function(value) {
			      scope.dateRangevalue = value;
			      scope.switchDate = true;
			      if(scope.dateRangevalue) {
			        if(value.startDate && value.endDate) {
			          scope.date_start = value.startDate.format('YYYY-MM-DD');
			          scope.date_end = value.endDate.format('YYYY-MM-DD');
			        } else {
						scope.date_start = null;
						scope.date_end = null;
					}
			      } else {
			          scope.date_start = null;
			          scope.date_end = null;
			      }
			    }
			    scope.onlyNumber = function(event) {
			       keyPressOnlyNumber(event) 
			    }
				scope.blurMaxUtilization = function() {
					if((scope.numberOfUses.max < scope.numberOfUses.count || !scope.numberOfUses.max) && scope.numberOfUses.count ) {
						scope.numberOfUsesError = true;
					}
				}
			    scope.changeMaxUtilization = function() {
			    	scope.numberOfUsesError = false;
			    	if((scope.numberOfUses.max < scope.numberOfUses.count || !scope.numberOfUses.max) && scope.numberOfUses.count ) {
			    		scope.numberOfUsesError = true;
			    		// scope.numberOfUses.max =  scope.numberOfUses.count;
			    		// $timeout(function() {
			    		// 	scope.numberOfUsesError = false;
			    		// },1000)
			    	}
				}
				function changeMediaStatus(postIds, param) {
					if(!postIds) return;
					$rootScope.hasLoaded = false;
					postDataService.save({
						param1:state,
						param2:'status',
						param3:param
					},{
						'ids': postIds,
					}).$promise.then(function(data){
						$rootScope.hasLoaded = true;
						getFunction();
					}, function(error){
						if(!window.navigator.onLine) {
							offlineError()
							$rootScope.hasLoaded = true;
							alertService('danger','Opps! ', 'Please check your internet connection and try again.');
							return
						}
						if(error.status ==401) {
							var promise = refreshtokenService.getAccessToken();
							promise.then(
								function(answer) {
									if(answer==200) {
										changeMediaStatus(postIds, param);
									}
								},
								function(error) {
									// report something
								},
								function(progress) {
									// report progress
							});
						} else if(error.status ==502) {
							serverError()
						} else {
							alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
						}
						$rootScope.hasLoaded = true;
					});
				}
				scope.changeMediaStatus = function(postId,param) {
					changeMediaStatus([postId], param)
				} 
				var unlockFunction = function(file_name) {
					$rootScope.hasLoaded = false;	
				    postDataService.save({
			          param1:state,
			          param2:'unlock',
			        },{
			        	'file_name': file_name,
			        }).$promise.then(function(data){
			        	$rootScope.hasLoaded = true;
								alertService('success','Success ', data.message, 2000);
								scope.mainImage = scope.editMediaCurrent.thumbs['830x0'];
								var mainImage = angular.element(document.getElementsByClassName("main-image"));
								mainImage.on('load',function() {
									scope.$apply(function() {
										scope.imageLocked = false;
									})
								})
			        }, function(error){
						if(!window.navigator.onLine) {
							offlineError()
							$rootScope.hasLoaded = true;
							alertService('danger','Opps! ', 'Please check your internet connection and try again.');
							return
						}
			          	if(error.status ==401) {
							var promise = refreshtokenService.getAccessToken();
							promise.then(
							function(answer) {
								if(answer==200) {
								  unlockFunction(file_name);
								}
							},
							function(error) {
								// report something
							},
							function(progress) {
							// report progress
							});
						} else if(error.status ==502) {
							serverError()
						} else {
							alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
						}
						$rootScope.hasLoaded = true;
			        });
			    }
				scope.unlockMedia = function(file) {
					if(config.baseMediaHref && file) {
						scope.mainImage = undefined;
						var file_name = file.substring(config.baseMediaHref.length)
						unlockFunction(file_name);
					}
				}
				$rootScope.closeEditMedia = function() {
					$rootScope.ngEscapeAttrsParametars = [];
					scope.media.editMediaShow= false;
					scope.editMediaCurrent = null;
					$state.transitionTo('app.library', {id: null}, {
		              location: true,
		              inherit: true,
		              relative: $state.$current,
		              notify: false
		            });
				}
				scope.searchPress = function(evt) {
			     keyPress(evt);
			    }
				scope.addNewTag = function(newTag) {
				    if(newTag) {
				        scope.newTagRequired = false;
			    		var newTag = newTag.toLowerCase();
				    	if(!checkArray.contains.call(scope.editMediaCurrent.tags,newTag)) {
					        scope.editMediaCurrent.tags.push(newTag);
					        scope.searchtagfocus = null;
					        scope.existTag = false;
				    	} else {
				    		scope.existTag = true;
				    	}
				    } else {
				        scope.newTagRequired = true;
				    }
			    }
			    scope.removeFromTagsList = function(index) {
			      scope.editMediaCurrent.tags.splice(index, 1);
			    }
			    // scope.getPdf = function() {
			    // 	token = authtokenService.getToken();
			    // 	var getPdfFunction = function() {
				// 		var req = new XMLHttpRequest();
				// 		var filename = scope.attachmentId + '-approval.pdf';
				// 	    req.open("GET", scope.approvalUrl, true);
				// 	    req.setRequestHeader('x-auth', token)
				// 	    req.responseType = "blob";
				// 	    req.onload = function (event) {
				// 	        var blob = req.response;
				// 	        var link=document.createElement('a');
				// 	        link.href=window.URL.createObjectURL(blob);
				// 	        link.style = "display: none";
            	// 		document.body.appendChild(link);  
				// 	        link.download=filename;
				// 	        link.click();
				// 	        setTimeout(function(){
				//               document.body.removeChild(link);
				//             },0)
				// 	    };
				// 	    req.send();
				//     }
				//     getPdfFunction();
			    // }
			    // scope.removePdf = function() {
			    // 	scope.approval = undefined;
			    // 	scope.approvalRemoved = true;
			    // 	scope.approvalUrl = undefined;
			    // }
			    var getDataInitFuncion = function(data) {
			    	// scope.approvalUrl = false;
			    	scope.editMediaCurrent = data;
			     	scope.mainImage = scope.editMediaCurrent.thumbs['830x0'];
			     	scope.editMediaCurrent.tags = checkArray.removeDuplicate(data.tags);
			     	// scope.approvalRemoved = false;
			     	if(data.restrictions) {
			     		
			     		if(data.restrictions.use_max && data.restrictions.use_max >=0) {
			     			scope.photoRestriction = true;
			     			scope.numberOfUses.max = data.restrictions.use_max
			     		}
			     		if(data.restrictions.date_to && data.restrictions.date_from) {
			     			scope.photoRestriction = true;
							 console.log(data.restrictions.date_to)
			     			$timeout(function() {
			     				scope.$broadcast('initial-daterange',{date:{start_date:data.restrictions.date_from,end_date:data.restrictions.date_to}})	
			     			},0);	
			     		}
			     		if(data.restrictions.use_count && data.restrictions.use_count>=0) {
			     			scope.numberOfUses.count = parseInt(data.restrictions.use_count);
			     		} else {
							scope.numberOfUses.count = 0;
						}
			     		if(data.restrictions.use_post_id ) {
			     			if(data.restrictions.use_post_id.length > 0) {
			     				scope.arrayOfPostsImageIncluded = data.restrictions.use_post_id
			     			} 
			     		}
			     		if(data.restrictions.locked) {
			     			scope.lockedImage = data.restrictions.locked;
			     		}
			     	}
		     		// if(data.approval_url) {
		     		// 	scope.approvalUrl = data.approval_url;
		     		// }	
			    }
			    var getFunction = function() {
				    getDataService.get({param1:state, param2: scope.attachmentId}).$promise.then(function(data){
				     	getDataInitFuncion(data)
				    }, function(error){
						if(!window.navigator.onLine) {
							offlineError()
							return
						}
				        if(error.status ==401) {
					        var promise = refreshtokenService.getAccessToken();
					        promise.then(
					          function(answer) {
					            if(answer==200) {
					              getFunction();
					            }
					          },
					          function(error) {
					            // report something
					          },
					          function(progress) {
					           // report progress
					        });
				        }else if(error.status ==502) {
			                serverError();
		                } else {
					        scope.media.editMediaShow= false;
					        $rootScope.hasLoaded = true;
					        $state.transitionTo('app.library', {id: null}, {
				              location: true,
				              inherit: true,
				              relative: $state.$current,
				              notify: false
				            });
				      	}
				    }); 
			    }
			    getFunction();
			    var postFunction = function() {
			    	scope.restrictions = undefined;
					if(scope.numberOfUsesError) {
						alertService('danger','Opps! ', 'Maximum utilization is incorrect');
						$rootScope.hasLoaded = true;
						return
					}
			    	if(scope.photoRestriction && (scope.numberOfUses.max || scope.date_start)) {
			            scope.restrictions = {
			                date_from : (scope.date_start)? scope.date_start: undefined,
			                date_to : (scope.date_end)? scope.date_end: undefined,
			                use_max : (scope.numberOfUses.max)? parseInt(scope.numberOfUses.max) : undefined
			            }
			        }
			        // if(!scope.approval) scope.approval = undefined;	
				    postDataService.save({
			          param1:state,
			          param2:'update',
			          id:scope.attachmentId
			        },{
			        	'title': scope.editMediaCurrent.title,
			        	'signature': scope.editMediaCurrent.signature,
			        	'image_alt': scope.editMediaCurrent.image_alt,
			        	'description': scope.editMediaCurrent.description,
						'signature_url': scope.editMediaCurrent.meta.signature_url,
						'gallery_title': scope.editMediaCurrent.gallery_title,
			        	'tags': scope.editMediaCurrent.tags,
			        	'restrictions': scope.restrictions,
			        	// 'approval':scope.approval
			        }).$promise.then(function(data){
			        	$rootScope.hasLoaded = true;
			        	getDataInitFuncion(data.post)
			            alertService('success','Success ', data.message, 2000);
			            scope.newFileRestriction = undefined;
			        }, function(error){
						if(!window.navigator.onLine) {
							offlineError()
							$rootScope.hasLoaded = true;
							alertService('danger','Opps! ', 'Please check your internet connection and try again.');
							return
						}
						if(error.status ==401) {
							var promise = refreshtokenService.getAccessToken();
							promise.then(
							function(answer) {
								if(answer==200) {
								postFunction();
								}
							},
							function(error) {
								// report something
							},
							function(progress) {
							// report progress
							});
						} else if(error.status ==502) {
							serverError()
						} else {
							alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
						}
						$rootScope.hasLoaded = true;
			        });
			    }
			    scope.updateMedia = function() {
			    	var validation = true;
			    	if(!scope.editMediaCurrent.title) {
			    		scope.titleRequired = true;
			    		validation = false
			    	} else {
			    		scope.titleRequired = false;
						}
						// if(scope.titleExceed) {
						// 	validation = false;
						// 	alertService('danger','Opps! ', 'Maximum number of characters in description is 200');
						// }
						if(validation) {
							$rootScope.hasLoaded = false;
							postFunction();
						} 
			    }
			    var deleteFunction = function() {
			      putDataService.update({
			        param1:'attachments', 
			        param2: 'bulk',
			        param3:'delete'
			        },{
			          'delete_ids':scope.checkedPostsforDelete,
			        }).$promise.then(function(bulkDelete){
			        $rootScope.hasLoaded = true;
			          scope.checkedPostsforDelete = [];
			          alertService('success','Success ', bulkDelete.message, 2000);
			          scope.media.tableParams.reload();
			          $timeout(function() {
				          $rootScope.closeEditMedia();
			          },0)
			      }, function(error){
					if(!window.navigator.onLine) {
						offlineError()
						$rootScope.hasLoaded = true;
						alertService('danger','Opps! ', 'Please check your internet connection and try again.');
						return
					}
			        if(error.status ==401) {
			          var promise = refreshtokenService.getAccessToken();
			          promise.then(
			            function(answer) {
			              if(answer==200) {   
			                deleteFunction();
			              }
			            },
			            function(error) {
			              // report something
			            },
			            function(progress) {
			             // report progress
			          });
			        }else if(error.status ==502) {
			          serverError();
			        } else {
			          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
			        }
			        $rootScope.hasLoaded = true;  
			      });
			    }
			    scope.deleteMedia = function() {
			    	$rootScope.hasLoaded = false;
				    scope.checkedPostsforDelete= [];
				    scope.checkedPostsforDelete.push(scope.attachmentId);
				    deleteFunction();  
			    }
			}
			
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/mediaModule/library/js/directive/mediaEditDirective.js
// module id = 516
// module chunks = 0